import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class Deposito extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'pago-deposito/one', saveUrl: 'pago-deposito/save', backUrl: '/Cobranza/Pagos' },
      new Form([
        Form.Field('number', 'importe', 'Importe', '', [Validators.required], 6, [], [], [], false, true),
        Form.Field('select', 'id_plazo', 'Plazo', '', [Validators.required], 6, [{ Label: 'Contado', Value: '1' }, { Label: 'Credito', Value: '2' }]),
        Form.Field('select', 'id_sucursal', 'Sucursal', '', [Validators.required], 6),
        Form.Field('select', 'tipo_pago', 'Tipo de pago', '1', [Validators.required], 6, [
          { Label: 'Pago Normal', Value: '1' },
          { Label: 'Pago por factoraje', Value: '2' },
          { Label: 'Intereses', Value: '3' },
        ]),
        Form.Field('autocomplete', 'id_cliente', 'Cliente', '', [Validators.required], 12),
      ], ['Guardar'], 'Control de dépositos'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  LoadPreds = async (predId = null) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`pago-deposito/one/${id}`);
    if (!Res.error) {
      console.log(Res.data);
      this.id_cliente = Res.data.id_cliente;
      let formData = await Form.Patch(this.state.FormData, Res.data, true)
      formData = await this.formData(formData);
      this.setState({
        FormData: formData,
        linea: Res.data.linea,
        restante: parseFloat(Res.data.restante),
        timbrado: Res.data.timbrado,
        id_cliente: Res.data.id_cliente,
      });
    }
  }

  formData = async (form) => {
    let newForm = form;

    const Res = await Http.get(`pago-deposito/form?q=1&${this.clienteSearch ? `cliente=${this.clienteSearch}` : ''}${this.id_cliente ? `&id_cliente=${this.id_cliente}` : ''}`);
    this.clienteSearch = '';
    if (this.id_cliente) {
      this.id_cliente = false;
    }
    if (!Res.error) {
      let { sucursales, clientes } = Res.data;
      // const clienteVario = { id: 0, cliente: "Varios" };
      // if (!clientes) clientes = [clienteVario];
      // else clientes.unshift(clienteVario);
      newForm = Form.FieldOptions(form, 'id_sucursal', sucursales, 'id', 'sucursal');
      if (clientes) {
        newForm = Form.FieldOptions(newForm, 'id_cliente', clientes, 'id', 'cliente');
      }
    }

    newForm = Form.ValueChange(newForm, {
      id_cliente: this.clienteChange,
    });
    return newForm;
  }

  clienteChange = async (field) => {
    if (field.ValueAt) {
      this.clienteSearch = field.ValueAt;
      this.id_cliente = field.Value;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  }

  onSubmit = async (i, vals) => {
    vals.id = this.props.match.params.id;
    var Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      const { id_pago } = Res.data;
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
      this.props.history.push(`/Cobranza/DepositosDetalle/${id_pago}`)
      this.props.onSave();
    } else {
      this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });
    }

  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Deposito)
